module.exports = __webpack_public_path__ + "img/16581250_L.51fbd8c7.png";